// Founder profile generation data

const firstNames = [
  "Chad", "Braden", "Tyler", "Jayden", "Hunter", "Austin", "Colton", "Blake",
  "Tanner", "Brock", "Preston", "Griffin", "Sterling", "Holden", "Easton",
  "Weston", "Beckett", "Thatcher", "Camden", "Reid", "Barrett", "Maverick",
  "Archer", "Dashiell", "Grayson", "Landon", "Pierce", "Caspian", "Declan",
  "Rhett", "Finnegan", "Hendrix", "Karter", "Axel", "Zander",
  "Braxton", "Chaz", "Thad", "Brantley", "Skyler", "Jett", "Thor",
  "Blaze", "Cash", "Bentley", "Kodiak", "Stetson", "Brixton", "Crew",
  "Raj", "Arjun", "Vikram", "Rohan", "Nikhil", "Sanjay", "Pranav", "Aditya",
  "Kevin", "Jason", "Brian", "Daniel", "Eric", "Ryan", "Andrew", "Justin",
  "Winston", "Derek", "Marcus", "Andre", "Jamal", "Darius", "Malik", "Omar",
];

const lastNames = [
  "Worthington III", "McKinsey", "Disrupton", "Blockchain", "Synergy",
  "Pivot", "Ventures", "Accelerator", "Tokensworth", "Leverage",
  "Stackowitz", "Van Equity", "Burnrate", "Del Monte Carlo", "Vaporware",
  "Pitchdeck", "Runwayson", "Cap-Table", "Unicornsby", "Scalington",
  "Growthstein", "Fundington", "Metaversely", "Dropshipley", "Hackathon",
  "Disruptson", "Valuationberg", "Minimum-Viable", "Iterateson", "Agileton",
  "De Startupé", "Optimizely Jr.", "Cryptobro", "Demoday", "Pivotski",
  "Ponzi-Schemington", "Theranos Jr.", "FTX-Was-Fine", "Rugpullman",
  "Trust-Me-Bro", "Due-Diligence-Optional", "Fauxpreneur", "Griftenhaus",
  "Von Nepotism", "Bailoutson", "Scamsworth IV", "Influencerberg",
  "Daddy's-Money", "NFT-Was-Real", "Fyre-Festival-Was-Misunderstood",
];

const taglines = [
  "Ex-Google → Ex-Meta → Stealth Mode",
  "Stanford CS dropout (by choice)",
  "YC W26 | Pre-revenue, Post-hype",
  "Building the Uber for {mundane}",
  "Serial entrepreneur (0 exits)",
  "Raised $4.2M to disrupt {industry}",
  "$0 ARR but vibes are immaculate",
  "I don't have a startup yet but I have a Patagonia vest",
  "Looking for a technical co-founder (I'm the ideas guy)",
  "My AI wrapper has an AI wrapper",
  "Prompt engineer → CEO pipeline",
  "I mass-applied to YC 7 times, manifesting S26",
  "Left FAANG to build a to-do app with LLMs",
  "Marched for billionaires unironically",
  "Web3 is dead, long live Web5",
  "Making the world a better place through scalable cloud solutions",
  "First-principles thinker (I watched 3 Elon interviews)",
  "10x founder, 0.1x developer",
  "I pivot faster than a Peloton instructor",
  "My pitch deck has more slides than my product has users",
  "Disrupting disruption itself",
  "Former crypto influencer (reformed)",
  "I network therefore I am",
  "Angel investor (minimum check: $50)",
  "Failed upward my entire career",
  "My dad's lawyer is my board of directors",
  "I put 'CEO' in my Hinge bio and it works",
  "Dropped out of 3 schools to maximize my dropout cred",
  "Banned from 2 WeWorks and a Panera Bread",
  "My therapist is also my business advisor",
  "Got rejected from YC so I started my own accelerator (also rejected)",
  "Professional conference attendee, amateur everything else",
  "I list 'breathing' under special skills",
  "My LinkedIn has more endorsements than my product has users",
  "Unemployable by choice (and also by everyone else)",
  "Trust fund kid cosplaying as a scrappy founder",
  "I've been 'about to launch' for 14 months",
];

const mundaneThings = [
  "laundromats", "dentist appointments", "park benches", "shoelaces",
  "elevator buttons", "napkins", "door hinges", "speed bumps",
  "parking meters", "salad bars", "dog walking", "lawn mowing",
  "stamp collecting", "bird watching", "envelope licking", "ice cube trays",
  "coat hangers", "pencil sharpening", "paperclip distribution",
];

const industries = [
  "the pencil industry", "public restrooms", "park benches",
  "the doorbell market", "artisanal toast", "umbrella rentals",
  "competitive napping", "handshake consulting", "elevator music",
  "waiting rooms", "the napkin space", "manual dishwashing",
];

const startupNames = [
  "VibeCorp", "DisruptAI", "SynergyOS", "PivotLabs", "HustleStack",
  "GrindDAO", "ScaleForce", "BuzzMetrics", "NapTech", "BlockVibes",
  "YOLOfi", "MoonBase", "EquityBro", "LeverageIQ", "RunwayAI",
  "VaporCloud", "SteathKit", "DemoDay.io", "PitchPerfect", "FounderFuel",
  "AlphaGrind", "ZenBurn", "TokenMint", "ChadStack", "VibeCheck",
  "SaaSBro", "ThinkTankr", "Unicornify", "GrowthOS", "HyperPivot",
];

const startupDescriptions = [
  "AI-powered {mundane} marketplace",
  "Uber for {mundane} — but decentralized",
  "A blockchain-verified {mundane} platform",
  "We're making {mundane} sexy again",
  "Tinder meets LinkedIn but for {mundane}",
  "The world's first subscription {mundane} service",
  "An AI that watches you do {mundane} and gives feedback",
  "Disrupting {industry} with machine learning",
  "Web5 infrastructure for {industry}",
  "A Notion template that solves {industry}",
  "ChatGPT wrapper for {industry}",
  "Making {industry} accessible, equitable, and vibes-based",
  "The operating system for {industry}",
  "Social network where people bond over {mundane}",
  "Robot-as-a-Service for {mundane}",
];

const askAmounts = [
  "$500K pre-seed", "$1.2M seed", "$3M Series A", "$250K angel round",
  "$50K (from you specifically)", "$2M at a $40M valuation (non-negotiable)",
  "$800K SAFE note", "$5M (we'll explain the valuation later)",
  "$100K for 0.5% equity", "$1.5M to hire a CTO (I'm the ideas guy)",
  "$420K (nice)", "$10M Series B (we skipped A)",
];

const traction = [
  { label: "MRR", value: "$0" },
  { label: "MRR", value: "$12 (my mom's subscription)" },
  { label: "MRR", value: "$47" },
  { label: "Users", value: "3 (including me)" },
  { label: "Users", value: "12 waitlist signups" },
  { label: "Users", value: "847 (all bots)" },
  { label: "Downloads", value: "7" },
  { label: "DAU", value: "1 (me, checking if the server is up)" },
  { label: "Revenue", value: "Negative" },
  { label: "Growth", value: "∞% WoW (from 0 to 1 user)" },
  { label: "Burn Rate", value: "$8K/mo (mostly DoorDash)" },
  { label: "Runway", value: "3 weeks" },
  { label: "NPS", value: "My mom gave us a 10" },
  { label: "Valuation", value: "$12M (vibes-based)" },
  { label: "TAM", value: "$8T (everyone is our market)" },
  { label: "Churn", value: "100% (but they'll come back)" },
  { label: "Runway", value: "Until my parents find out" },
  { label: "CAC", value: "$4,200 per user" },
];

const hobbies = [
  "Networking at coffee shops", "Cold DMing on LinkedIn", "Listening to podcasts about hustle",
  "Microdosing and 'ideating'", "Reading PG essays at 4am", "Biohacking my morning routine",
  "Organizing founder dinners", "Meditating (for productivity)", "CrossFit (for the metaphors)",
  "Journaling about my startup journey", "Angel investing ($50 checks)", "Going to Demo Days",
  "Updating my Notion life dashboard", "Tweeting threads about grit", "Hot yoga (for networking)",
  "Building Lego (it's like product development)", "Watching Shark Tank for 'research'",
  "Curating my personal brand", "Running (from my responsibilities)", "Reading VC Twitter",
  "Attending Web3 conferences", "Making vision boards", "Float tank sessions",
  "Writing unsolicited pitch emails", "Drinking Soylent competitively",
  "Collecting restraining orders", "Getting banned from things",
  "Writing anonymous Glassdoor reviews", "Evading process servers",
  "Arguing with strangers on Twitter/X", "Filing frivolous lawsuits",
  "Catfishing VCs on LinkedIn", "Sending unsolicited legal threats",
  "Starting drama in Slack channels", "Taking credit for other people's work",
];

const education = [
  "Stanford CS (dropped out week 3)", "Harvard MBA (asked to leave)",
  "MIT Sloan (audited one class)", "Y Combinator University (rejected)",
  "Thiel Fellowship (application pending since 2019)", "UC Berkeley (Go Bears!)",
  "School of Hard Knocks (self-proclaimed)", "Codecademy Pro (3 lessons completed)",
  "YouTube University", "LinkedIn Learning (47 certificates)",
  "Wharton (I toured the campus once)", "Princeton (visited a friend there)",
  "Self-taught (watched 2 TED talks)", "Duke (my dad went there)",
  "Udemy Masterclass Graduate", "Community College → Stanford GSB (manifesting)",
  "Banned from 3 universities (details sealed)", "Harvard (restraining order from admissions)",
  "Stanford (trespassed on campus, claimed enrollment)", "MIT (forged acceptance letter)",
  "Expelled for selling NFTs of professor's lectures", "Online degree from a website that no longer exists",
  "PhD in Disruption (self-awarded)", "Degree pending investigation",
];

const resumeHighlights = [
  'CEO & Founder, Stealth Startup (2 weeks)',
  "Disrupted my parents' garage into a co-working space",
  "Published thought leadership on LinkedIn (47 likes)",
  "Built an AI-powered AI that uses AI to optimize AI",
  "Attended 14 YC Demo Days (as audience)",
  "Angel invested $500 in my roommate's NFT project",
  "Harvard MBA dropout (asked to leave)",
  "Fluent in buzzwords, pitch decks, and cold DMs",
  'Organized a "March for Billionaires" in SF',
  "Networking is my full-time job",
  "3x failed startups (but the learnings were incredible)",
  "Built a $0 company valued at $12M on vibes alone",
  "My startup: it's like {company} but worse",
  "Podcast host (12 subscribers, 9 are family)",
  "Sold my startup (to myself, for tax purposes)",
  "Technical skills: I can make a Notion dashboard",
  "Sent 2,000 cold LinkedIn DMs (3 responses, all 'unsubscribe')",
  "Converted my bedroom into an 'innovation lab'",
  "Invented a blockchain solution for a problem that doesn't exist",
  "Raised a pre-seed round from my parents' retirement fund",
  "Built an MVP in a weekend (it's been the MVP for 2 years)",
  "Keynote speaker at my own meetup (4 attendees)",
  "Growth hacked my way to 200 Twitter followers",
  "Wrote a 47-page pitch deck for a lemonade stand",
  "Chief Vibes Officer at a stealth startup",
  "Created an NFT of my business card",
  "Completed a 6-week coding bootcamp (dropped out week 4)",
  "My product roadmap is just a screenshot of someone else's app",
  "Founded a DAO with my two roommates",
  "Metrics: 3 downloads (2 were me testing on different phones)",
  "Pivoted 7 times in 6 months (personal best)",
  "Built a Chrome extension that has more bugs than features",
  "Fired my co-founder (it was my dog)",
  "Listed 'CEO' on my resume before having a company",
  "Accidentally emailed my pitch deck to my therapist",
  "My cap table is an unpaid bar tab",
  "Sued by my own LLC for emotional damages",
  "Took a gap year that has lasted 6 years",
  "Rebranded unemployment as 'founder mode'",
  "Spent $8K on a logo before having a product",
  "My startup's biggest competitor is my own laziness",
  "Got banned from a WeWork for sleeping in the phone booth",
  "Hired an intern to write my YC application (rejected)",
  "My financial model is a screenshot of someone else's spreadsheet",
  "Pitched to a VC at a urinal (he passed)",
  "References available upon request (please don't call them)",
  "Put 'proficient in Excel' — I can open the app",
  "Hosted a startup retreat (just me at an Airbnb for a week)",
  "Trademarked a word that already existed",
  "My competitive advantage is that I have no competition (no market)",
  "Turned my Tinder bio into a pitch deck",
  "Got a cease and desist from the real {company}",
  "My 'team page' is just my LinkedIn photo 5 times in different shirts",
  "Raised $0 at a $50M valuation (self-assessed)",
  "Spent runway money on a team offsite in Bali (solo trip)",
  "My exit strategy is marrying into wealth",
  "Filibustered my own board meeting for 3 hours",
  "Claimed 'product-market fit' because my mom uses the app",
  "Wrote 'experienced leader' — I led a group project once in college",
  "My startup failed but the merch still sells",
  "Applied to Y Combinator from a McDonald's WiFi",
  "Banned from 4 college campuses (can't say why)",
  "HR complaint speedrunner (personal best: 3 in one day)",
  "Under investigation by the SEC (they're just jealous)",
  "Restraining order from my previous co-founder",
  "Described as 'potentially problematic' by 6 former employees",
  "Asked to leave a TED Talk for heckling the speaker",
  "My Glassdoor rating is 1.2 stars (I wrote all the 5-star reviews)",
  "Blacklisted from Y Combinator, Techstars, AND 500 Startups",
  "Currently in a legal dispute with my own mother over equity",
  "Kicked out of a networking event for pitching at the buffet table",
  "Was once described as 'a walking red flag' by TechCrunch",
  "Lied on this resume (but I won't tell you which part)",
  "My last 3 co-founders all have restraining orders against me",
  "Permanently banned from LinkedIn (made a new account)",
  "Embellished my resume (this is the honest version)",
  "My employee retention rate is technically classified",
  "Got escorted out of a board meeting I wasn't invited to",
  "Multiple pending lawsuits (details available upon request)",
  "My investors call me 'the liability'",
  "Holds the record for fastest HR complaint at {company}",
  "Described as 'aggressively unemployable' by a career counselor",
  "Was on a watchlist at Stanford (not the good kind)",
  "Fired from an unpaid internship for 'cultural differences'",
  "My background check requires its own background check",
];

const companies = [
  "Uber", "Airbnb", "Slack", "Notion", "Figma", "Stripe", "LinkedIn",
  "WeWork", "Theranos", "Juicero", "Clubhouse", "Quibi",
];

const locations = [
  "0.3 mi away (at the same WeWork)",
  "0.1 mi away (standing behind you)",
  "2 mi away (Mission District coffee shop)",
  "0.5 mi away (Philz Coffee, obviously)",
  "1 mi away (his parents' house in Palo Alto)",
  "0.2 mi away (sleeping at the office)",
  "3 mi away (a hacker house with 9 roommates)",
  "0 mi away (he followed you here)",
  "0.4 mi away (Burning Man planning meeting)",
  "1.5 mi away (meditating at a float tank)",
];

const badges = [
  "YC Reject", "'Visionary'", "Thought Leader", "Hustle Culture",
  "Idea Guy", "10x Networker", "Vibe CEO", "Serial Pivoter",
  "AI Enthusiast", "Web3 Survivor", "Pitch Deck Warrior", "Stealth Mode",
  "Pre-Revenue", "Post-Hype", "Self-Funded (parents)", "Growth Hacker",
  "Disruptor", "Synergist", "Paradigm Shifter", "Move Fast Break Things",
  "HR Nightmare", "Walking Red Flag", "Campus-Banned", "Under Investigation",
  "Banned From LinkedIn", "Pending Lawsuit", "Probably Lying", "Flight Risk",
  "Do Not Google", "Uninsurable", "NDA Required", "Background Check Failed",
];

const rejectMessages = [
  "You just saved $50K in diluted equity 💸",
  "Another one bites the dust(ruption) 🪦",
  "Your cap table thanks you 📊",
  "He's already sliding into someone else's DMs 📱",
  "Rejected! His pitch deck will haunt your dreams anyway 👻",
  "PASS. He'll be fine — he has a trust fund 💰",
  "You dodged a 47-slide pitch deck bullet 🎯",
  "Declined. He's already calling it a 'learning experience' 📝",
  "Your inbox just breathed a sigh of relief 📧",
  "Rejected! Don't worry, he's disrupting rejection itself 🔄",
  "NOPE. He'll blame the market conditions 📉",
  "Saved yourself from a 3-hour coffee 'brainstorm session' ☕",
  "Your Calendly link lives to see another day 📅",
];

const matchMessages = [
  "Congrats! You've been added to his cap table 📈",
  "He's already CC'd you on a 47-person email thread 📧",
  "You matched! He's already updating his LinkedIn bio 🔗",
  "IT'S A MATCH! Prepare for the pitch deck in 3... 2... 1... 📊",
  "Funded! He's naming the conference room after you 🏢",
  "You matched! He just added 'backed by [YOU]' to his Twitter bio 🐦",
  "Congrats! You're now a 'strategic advisor' (unpaid) 🤝",
  "MATCH! He's already invited you to his podcast 🎙️",
  "You funded him! Your money is now in vibes form ✨",
  "He's texting his mom that he found an investor 📱",
  "MATCH! The Patagonia vest just got zipped up with excitement 🦺",
  "Funded! He's already spending it on a team offsite in Tulum 🏖️",
  "You matched! He's already asking if you know any engineers 👨‍💻",
];

// Deterministic shuffle using a seed
function seededRandom(seed) {
  let s = seed;
  return function () {
    s = (s * 1664525 + 1013904223) & 0xffffffff;
    return (s >>> 0) / 0xffffffff;
  };
}

function pickRandom(arr, rng) {
  return arr[Math.floor(rng() * arr.length)];
}

function pickRandomN(arr, n, rng) {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled.slice(0, n);
}

function processTagline(tagline, rng) {
  return tagline
    .replace("{mundane}", pickRandom(mundaneThings, rng))
    .replace("{industry}", pickRandom(industries, rng));
}

function processHighlight(highlight, rng) {
  return highlight.replace("{company}", pickRandom(companies, rng));
}

// Unhinged things a VC / tech bro cofounder would say
const speechBubbles = [
  // Obnoxious startup bro
  "We're not a startup, we're a movement",
  "I don't need sleep, I need equity",
  "My therapist says I should stop calling users 'growth vectors'",
  "We're pre-revenue but post-vibe",
  "I literally invented hustle culture",
  "Let me disrupt your lunch real quick",
  "I pitched my dog walker and she passed",
  "We're basically Uber meets Tinder meets blockchain",
  "I have 47 slides, you have 5 minutes",
  "My co-founder is ChatGPT",
  "I sold my bed to extend our runway",
  "Sleep is a feature we haven't shipped yet",
  "I cold DM'd 2,000 VCs from a Denny's parking lot",
  "We pivot every Monday, it's part of our culture",
  "I network in my sleep. Literally. I sleep-talk about TAM",
  "My cap table is a Google Sheet with conditional formatting",
  "We don't have users yet but the waitlist has a waitlist",
  "I'm not unemployed, I'm in stealth mode",
  "Our burn rate is a vibe",
  "I only eat Soylent so I can pitch during lunch",
  "We're disrupting disruption as a service",
  "My pitch deck has more animations than Pixar",
  "I meditation-hacked my way to product-market fit",
  "Can I expense my Patagonia vest?",
  "We're like Airbnb but for thoughts",
  "I NFT'd my business card",
  "The market is everyone. Literally everyone",
  "We don't have competitors, we have future acquisitions",
  "I pitched at my grandmother's funeral. She would've wanted it",
  "Our moat is vibes",
  "I maxed out 3 credit cards but the MRR is coming",
  "Let me tell you about our AI-powered AI",
  "I don't have a salary, I have a destiny",
  "I'm basically Elon Musk but with better hair",
  "My IQ is higher than my burn rate. And my burn rate is $40K a month",
  "I was told I'm 'too visionary' for this world",
  "You wouldn't understand my startup. Nobody does. That's the point",
  "I don't do small talk, I do term sheets",
  "My morning routine takes 4 hours and involves an ice bath",
  "I only date people who understand cap tables",
  "I've been told I have 'main character energy' by myself",
  "Everyone at this party is a potential investor to me",
  "I read 47 books a year. Well, book summaries. Well, tweets about books",
  "I don't believe in weekends. Weekends are for people without vision",
  "My net worth is negative but my confidence is infinite",
  // Hitting on you / flirty
  "Hey, are you a VC? Because I'd love to get into your portfolio",
  "You look like someone who appreciates a good pitch deck",
  "Is your name Series A? Because I've been looking for you my whole life",
  "Do you believe in love at first pitch?",
  "Are you an angel investor? Because you just fell from heaven",
  "I'd give you equity in my heart. Non-dilutable",
  "You're the product-market fit I've been searching for",
  "Forget my startup, YOU'RE the real unicorn here",
  "My runway is short but my love for you is infinite",
  "Can I add you to my cap table? Under 'significant other'",
  "You had me at 'what's your valuation'",
  "I'd pivot my entire business model for you",
  "Are you a SAFE note? Because I feel a conversion happening",
  "I've been in stealth mode until I saw you walk in",
  "You're disrupting my ability to focus on anything else",
  "I'd burn through my entire runway just to take you to dinner",
  "My heart just did a hockey stick growth curve when I saw you",
  "I don't usually pitch to strangers, but for you I'll make an exception",
  "Are you Y Combinator? Because you just accelerated my heart rate",
  "I'd give you my last share of equity",
  "Swipe right and I'll let you be on my board of directors",
  // Extra obnoxious
  "I'm not bragging but my pitch deck made a VC cry once. He was laughing but still",
  "I am the smartest person in every room I walk into. Including this one",
  "People say I'm arrogant. I prefer 'accurately self-assessed'",
  "I don't need your money. I mean I do. But I don't NEED it. Please invest",
  "I'm too important for a real job, that's why I'm a founder",
  "My startup is valued at $50M. I did the valuation myself",
  "I'm not here to make friends. I'm here to disrupt friendships",
  "If you don't fund me, you'll regret it. I'll make sure of it",
  "I sent my pitch deck to God. Still waiting on a reply but feeling good",
  "I'm basically a genius. I took an online IQ test and it confirmed it",
  // Delusional confidence
  "I turned down Google. Well, they never offered. But I would have turned them down",
  "My investor update email is longer than most novels",
  "I have a tattoo of my company logo. We pivoted two weeks later",
  "I practice my TED Talk in the shower every morning",
  "I once got a standing ovation at a pitch. I was the only one in the room",
  "My LinkedIn headline is longer than my resume",
  "I describe myself as a 'serial entrepreneur' after one failed lemonade stand",
  "I've been compared to Steve Jobs. By me. Just now",
  "My business card has a QR code that links to another QR code",
  "I wore a suit to a hackathon. Everyone else was in hoodies. I won nothing",
  "I have more advisors than customers",
  "My startup's Slack has 47 channels and 2 employees",
  "I listed myself as 'Forbes 30 Under 30 (pending)' on LinkedIn",
  "I once filibustered a standup meeting for 45 minutes",
  "My product demo crashed live on stage. I called it 'authentic'",
  // Creepy/flirty escalation
  "I Googled you before this. Your GitHub is mid but your smile isn't",
  "You look like someone who needs a technical co-founder in their life",
  "I wrote an algorithm that says we're 97% compatible. Please don't ask to see it",
  "My love language is equity splits",
  "I made a vision board and you were on it. Don't ask how I got the photo",
  "I'd add you to my CRM. Under 'high priority leads'",
  "Are you a pivot? Because you just changed my entire direction",
  "I swiped right on you in my mind before this app existed",
  "I'd share my Netflix password AND my AWS credentials with you",
  "You're like a pre-seed round. Risky, but I'm all in",
  "My five-year plan now includes you. I just updated the Notion doc",
  "I'd let you read my term sheet. And that's the most intimate thing I can offer",
  // Unhinged behavior
  "I just Slacked my co-founder about you. He said 'please stop'",
  "I expense everything. This conversation? Tax deductible",
  "I haven't slept in 3 days but I've never been more productive. I think",
  "My doctor says I need to stop talking about TAM at dinner parties",
  "I cried during a board meeting once. Power move",
  "I named my cat 'Series A' and my dog 'Acquisition'",
  "I made a pitch deck for my Tinder dates. 12% conversion rate",
  "My therapist fired me as a client. Said I was 'too disruptive'",
  "I tried to negotiate the price at Starbucks. They called security",
  "I asked my barber for 'the founder cut'. He didn't know what that meant. Neither did I",
  "I set up a Calendly link for my family to book time with me",
  "I tried to raise a seed round at Thanksgiving dinner. My uncle blocked me",
  // Gross oversharing
  "I haven't done laundry in 3 weeks. I call it 'lean operations'",
  "I showered yesterday. Well, Tuesday. What day is it?",
  "I live in a van but I call it 'mobile headquarters'",
  "I eat all my meals over my keyboard. The spacebar is sticky",
  "My apartment smells like Red Bull and broken dreams",
  "I wear the same hoodie every day. It's my 'founder uniform'",
  // Desperate
  "Please swipe right. My mom is watching",
  "If you don't fund me, I'll have to get a real job. PLEASE",
  "I'll name a conference room after you. We don't have an office but still",
  "I'm running out of people to pitch to. You're literally my last hope",
  "My runway ends next Tuesday. No pressure",
  "I've been rejected 847 times. What's one more? Ha ha. Please",
  "I promise I'm not like the other founders. I'm worse. But in a fun way",
  "My parents think I'm a lawyer. Please don't tell them",
  // SF dating specific
  "I can't do dinner Tuesday, I have a founder dinner. Wednesday? Also founder dinner",
  "My love language is sending Loom videos at 2am",
  "I put 'open to co-founding' on my dating profile and it worked",
  "I've been on 40 first dates this quarter. My conversion rate is 0%",
  "Can we split the check? I'm conserving runway",
  "I scheduled this date in a 15-minute Calendly slot. We're at minute 12",
  "You remind me of my Series A. Beautiful, distant, and probably not happening",
  "My ex left me for a guy with actual revenue",
  "I'm emotionally unavailable but my API is always up",
  "I ghosted my last 3 dates. I prefer the term 'async communication'",
  "I can't commit to a relationship but I can commit to a 4-year vesting schedule",
  "My dating life has the same churn rate as my startup",
  "I treat dates like investor meetings. Here's my deck",
  "I only date people who've read Zero to One",
  "I described my breakup as a 'strategic pivot' on LinkedIn",
  "I brought a whiteboard to a date once. She didn't call back",
  "My Hinge prompt says 'looking for a co-founder with benefits'",
  "I rate dates by their potential ROI",
  "You're cute but can you code? We need a CTO",
  "I practice active listening. Well, I practice looking like I'm listening",
  // Tech bro delusion
  "AI will replace everything except founders. We're irreplaceable",
  "I don't believe in work-life balance. I believe in work-work balance",
  "My screen time is 14 hours a day but it's all productive. Mostly Twitter",
  "I optimized my sleep to 4 hours. I'm basically a zombie but a productive one",
  "I take cold showers, drink butter coffee, and still can't ship a product",
  "Elon replied to my tweet once. Well, it was a bot. But still",
  "I've been grinding for 3 years. No product, no revenue, but great abs",
  "I'm building in public. Mainly because I got evicted from my apartment",
  "My todo list is 847 items long. I've completed 3. All were 'make todo list'",
  "I replaced my entire personality with startup jargon and honestly? No regrets",
  "I don't have impostor syndrome. I AM the impostor",
  "People say I work too hard. Those people are called 'former friends'",
  "I missed my best friend's wedding for a hackathon. We didn't even win",
  "I have a morning routine that takes 6 hours. My workday starts at 3pm",
  "I call my apartment a 'live-work space'. It's a studio with a laptop",
  // Toxic positivity
  "Every rejection is just a 'not yet'. I've collected 200 'not yets'",
  "I failed forward so hard I'm basically moonwalking",
  "My therapist says I use toxic positivity as a defense mechanism. I told her that's a great opportunity for growth",
  "I turned my failures into a keynote speech. Nobody came but the slides were fire",
  "I'm not delusional, I'm 'reality-flexible'",
  "The universe owes me a Series A. I've done the manifestation work",
  "I journal every morning about my future billion-dollar exit. It's been 4 years",
  // Cringe networking
  "I LinkedIn DM'd every person at this party before arriving. Most blocked me",
  "Can I add you on LinkedIn? I add everyone. I have 12,000 connections and no friends",
  "I'm going to follow up on this conversation with a 7-part email sequence",
  "Let me add you to my Notion CRM. You're currently tagged as 'warm lead'",
  "I network at funerals. You'd be surprised how many decision-makers attend",
  "I have a spreadsheet ranking everyone I've ever met by their net worth",
  "I asked my dentist if he's an accredited investor. Mid-cleaning",
  "I turned my wedding into a networking event. My wife filed for divorce",
  // Self-awareness (lack thereof)
  "People say I'm hard to work with. I say those people lack vision",
  "I've been called 'a lot' by everyone I've ever met. I take it as a compliment",
  "My Uber rating is 2.3 stars. I pitch every driver",
  "Three of my friends started a group chat without me. It's called 'Peace At Last'",
  "I was voted 'most likely to become a LinkedIn influencer' in college. It wasn't a compliment",
  "My roommate moved out in the middle of the night. Left a note that said 'I can't do this anymore'",
  "I got uninvited from Thanksgiving. Something about 'not everything is a pitch opportunity'",
];

// HD transparent fullbody PNGs — all validated head-to-feet (pngimg.com, CC BY-NC 4.0)
const photoUrls = [
  // Businessman category
  "https://pngimg.com/d/businessman_PNG6538.png",
  "https://pngimg.com/d/businessman_PNG6542.png",
  "https://pngimg.com/d/businessman_PNG6548.png",
  "https://pngimg.com/d/businessman_PNG6556.png",
  "https://pngimg.com/d/businessman_PNG6571.png",
  "https://pngimg.com/d/businessman_PNG6573.png",
  "https://pngimg.com/d/businessman_PNG6583.png",
  // Man category
  "https://pngimg.com/d/man_PNG6500.png",
  "https://pngimg.com/d/man_PNG6503.png",
  "https://pngimg.com/d/man_PNG6504.png",
  "https://pngimg.com/d/man_PNG6505.png",
  "https://pngimg.com/d/man_PNG6506.png",
  "https://pngimg.com/d/man_PNG6512.png",
  "https://pngimg.com/d/man_PNG6513.png",
  "https://pngimg.com/d/man_PNG6519.png",
  "https://pngimg.com/d/man_PNG6520.png",
  "https://pngimg.com/d/man_PNG6522.png",
  "https://pngimg.com/d/man_PNG6523.png",
  "https://pngimg.com/d/man_PNG6524.png",
  "https://pngimg.com/d/man_PNG6532.png",
  // More diverse — Asian & Brown men
  "https://pngimg.com/d/man_PNG6514.png",
  "https://pngimg.com/d/businessman_PNG6554.png",
  "https://pngimg.com/d/businessman_PNG6567.png",
  "https://pngimg.com/d/businessman_PNG6544.png",
  "https://pngimg.com/d/businessman_PNG6550.png",
  "https://pngimg.com/d/businessman_PNG6552.png",
  "https://pngimg.com/d/businessman_PNG6558.png",
  "https://pngimg.com/d/businessman_PNG6560.png",
  "https://pngimg.com/d/businessman_PNG6562.png",
  "https://pngimg.com/d/businessman_PNG6564.png",
  "https://pngimg.com/d/businessman_PNG6568.png",
  "https://pngimg.com/d/businessman_PNG6570.png",
  "https://pngimg.com/d/businessman_PNG6572.png",
  "https://pngimg.com/d/businessman_PNG6574.png",
  "https://pngimg.com/d/businessman_PNG6576.png",
  "https://pngimg.com/d/businessman_PNG6578.png",
  "https://pngimg.com/d/businessman_PNG6580.png",
  "https://pngimg.com/d/businessman_PNG6582.png",
];

export function generateFounders(count = 40) {
  const founders = [];
  const usedNames = new Set();

  // Shuffle photos so no two founders share the same image
  const shuffledPhotos = pickRandomN(photoUrls, photoUrls.length, seededRandom(12345));

  for (let i = 0; i < count; i++) {
    const rng = seededRandom(i * 7919 + 42);

    let fullName;
    do {
      const first = pickRandom(firstNames, rng);
      const last = pickRandom(lastNames, rng);
      fullName = `${first} ${last}`;
    } while (usedNames.has(fullName));
    usedNames.add(fullName);

    const age = 24 + Math.floor(rng() * 8); // 24-31
    const tagline = processTagline(pickRandom(taglines, rng), rng);
    const highlights = pickRandomN(resumeHighlights, 3 + Math.floor(rng() * 2), rng)
      .map(h => processHighlight(h, rng));
    const location = pickRandom(locations, rng);
    const badge1 = pickRandom(badges, rng);
    let badge2;
    do {
      badge2 = pickRandom(badges, rng);
    } while (badge2 === badge1);

    const photoUrl = shuffledPhotos[i % shuffledPhotos.length];

    // Startup info
    const companyName = pickRandom(startupNames, rng);
    const companyDesc = pickRandom(startupDescriptions, rng)
      .replace("{mundane}", pickRandom(mundaneThings, rng))
      .replace("{industry}", pickRandom(industries, rng));
    const ask = pickRandom(askAmounts, rng);
    const metrics = pickRandomN(traction, 3, rng);
    const founderHobbies = pickRandomN(hobbies, 3, rng);
    const edu = pickRandom(education, rng);

    founders.push({
      id: i,
      name: fullName,
      age,
      tagline,
      highlights,
      location,
      badges: [badge1, badge2],
      quotes: pickRandomN(speechBubbles, 5, rng),
      photoUrl,
      companyName,
      companyDesc,
      ask,
      metrics,
      hobbies: founderHobbies,
      education: edu,
      avatarColor: `hsl(${Math.floor(rng() * 360)}, 60%, 45%)`,
      initials: fullName.split(" ").map(n => n[0]).join("").slice(0, 2),
    });
  }

  return founders;
}

export function getRandomRejectMessage() {
  return rejectMessages[Math.floor(Math.random() * rejectMessages.length)];
}

export function getRandomMatchMessage() {
  return matchMessages[Math.floor(Math.random() * matchMessages.length)];
}
